import {Switch} from '@wandb/weave/components';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import React, {useState} from 'react';

type SortOption = 'lastSaved' | 'lastCreated' | 'alphabetical';

type NamedWorkspaceSortOptionSelectorProps = {
  selectedOption: SortOption;
  onSelectOption: (option: SortOption) => void;
  shouldShowMyViewsOnly: boolean;
  onShowMyViewsOnly: (show: boolean) => void;
};

type ItemLabelProps = {
  isSelected: boolean;
  label: string;
};

const ItemLabel: React.FC<ItemLabelProps> = ({isSelected, label}) => (
  <div className="flex w-full justify-between">
    <span className="truncate text-moon-800 dark:text-moon-300">{label}</span>
    {isSelected && <Icon name="checkmark" />}
  </div>
);

type SortMenuItemProps = {
  option: SortOption;
  selectedOption: SortOption;
  onSelectOption: (option: SortOption) => void;
  label: string;
};

const SortMenuItem: React.FC<SortMenuItemProps> = ({
  option,
  selectedOption,
  onSelectOption,
  label,
}) => (
  <DropdownMenu.Item
    onSelect={() => onSelectOption(option)}
    className="flex items-center justify-between">
    <ItemLabel isSelected={selectedOption === option} label={label} />
  </DropdownMenu.Item>
);

export const NamedWorkspaceSortOptionSelector: React.FC<
  NamedWorkspaceSortOptionSelectorProps
> = ({
  selectedOption,
  onSelectOption,
  shouldShowMyViewsOnly,
  onShowMyViewsOnly,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu.Root
      open={isOpen}
      onOpenChange={setIsOpen}
      data-testid="sort-option-selector">
      <DropdownMenu.Trigger
        className="flex items-center"
        onClick={() => setIsOpen(!isOpen)}>
        <Button variant="ghost" icon="overflow-horizontal" active={isOpen} />
      </DropdownMenu.Trigger>

      <DropdownMenu.Content className="w-[13rem]" align="start">
        <DropdownMenu.Label className="flex gap-8 px-12 py-8 text-base font-semibold text-moon-800 dark:text-moon-50">
          Sorting
        </DropdownMenu.Label>

        <SortMenuItem
          option="alphabetical"
          selectedOption={selectedOption}
          onSelectOption={onSelectOption}
          label="Alphabetical"
        />

        <SortMenuItem
          option="lastSaved"
          selectedOption={selectedOption}
          onSelectOption={onSelectOption}
          label="Last saved"
        />

        <SortMenuItem
          option="lastCreated"
          selectedOption={selectedOption}
          onSelectOption={onSelectOption}
          label="Last created"
        />

        <DropdownMenu.Separator />

        <DropdownMenu.Item
          onSelect={e => {
            setIsOpen(true);
            e.preventDefault();
          }}
          className="flex items-center justify-between">
          <span className="text-moon-800 dark:text-moon-300">
            Show my views only
          </span>
          <Switch.Root
            id="switch"
            checked={shouldShowMyViewsOnly}
            size="small"
            onCheckedChange={checked => {
              onShowMyViewsOnly(checked);
            }}>
            <Switch.Thumb checked={shouldShowMyViewsOnly} size="small" />
          </Switch.Root>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
